import { render, staticRenderFns } from "./Gamma3_Express.vue?vue&type=template&id=f5bfc030&"
import script from "./Gamma3_Express.vue?vue&type=script&lang=js&"
export * from "./Gamma3_Express.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports